import Register from '@/views/auth/Register';

export default Register;
